import React, { Component } from 'react';
import config from './../../../config';
import common from './../../../common';
import { getTeamDeadlineObj } from './../../../helper-common';

class MdStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enumText: {
                'UT_CRT': { trans: 'createTeam', path: '/create-team' },
                'UT_TRF': { trans: 'manageTeam', path: '/manage-team' },
                'UT_LIVE': { trans: 'viewTeam', path: '/manage-team' },
                'UT_SUB': { trans: 'makeSubstitutions', path: '/manage-team' }
            },
        }
    }

    componentDidMount() {
        common.cardImpression('card-points', { variant: 'matchweek', position: '3' })
    }

    renderDetails(arrMatchDay, trans) {
        let resp = null;
        resp = arrMatchDay && arrMatchDay.map((element, index) => {
            const { date, points } = element;
            // let sDate = common.dateFormat(date, 'ddd d mmm');

            let dateObj = getTeamDeadlineObj(trans, this.props.constraints.OffSet, date, "", '', false, true);

            let sDate = dateObj.displayDate;
            let nodePoints = <span className="si-points"> - </span>;
            if (points) {
                nodePoints = (<React.Fragment>
                    <span className="si-points">{ points } </span><span className="si-pts-txt">{ trans.labelPts }</span>
                </React.Fragment>)
            }
            return (<div key={ index } className="si-stats-wrap">
                <span className="si-plyr-events">{ sDate }</span>
                <div className="si-pts-wrap">
                    {
                        nodePoints
                    }
                </div>
            </div>);
        });
        return resp;
    }

    renderPointSofar = (arrSchedule, arrMatchDay, enumScinarioCode, IsFixturePtCard, trans, isMdCompleted) => {
        let isSchedule = (config.enumMdCardStatus.fixture === IsFixturePtCard);//(arrSchedule.indexOf(enumScinarioCode) > -1);
        if (isSchedule) {
            return (<div className="si-mt-text-title">{ (arrMatchDay.length + " " + trans.daysOfMatches) }</div>);
        }
        else {
            let jPoints = 0;
            for (let j = 0; j < (arrMatchDay || []).length; j++) {
                let row = arrMatchDay[j];
                jPoints = jPoints + (row.points ? Number(row.points) : 0);
            }
            let ptText = isMdCompleted ? (trans.pointsSoFar ? trans.pointsSoFar : "points so far") : (trans.pointsScored ? trans.pointsScored : "points scored");
            return (<div className="si-mt-text-title">{ (jPoints + " " + ptText) }</div>);
        }
    };

    renderViewPointsBtn(arrSchedule, enumScinarioCode, IsFixturePtCard, trans) {
        let isSchedule = (config.enumMdCardStatus.fixture === IsFixturePtCard);//(arrSchedule.indexOf(enumScinarioCode) > -1);
        if (!isSchedule) {
            let self = this;
            return (<div className="si-btn btn-lg" onClick={ () => {
                common.customTracking('Fantasy Football - Points');
                self.onRedirectTo()
            } }>{ trans.viewPoints }</div>);
        }
        else {
            return null;
        }
    }

    onRedirectTo() {
        const { PtGameday } = this.props.gcStats;
        let enumText = this.state.enumText;
        let objText = enumText[this.props.enumUserScinarioCode];
        if (objText) {
            let sPath = objText.path;
            if (PtGameday) {
                sPath += '/' + PtGameday;
            }
            this.props.onRedirectTo(sPath);
        }
    }

    render() {
        let self = this;
        let trans = this.props.trans;
        let gcStats = this.props.gcStats;
        let arrMatchDay = [];
        let gamdayId = 0;
        let arrSchedule = [config.enumscinarioCode.preUnkownFixture, config.enumscinarioCode.preKownFixture, config.enumscinarioCode.startOfMatchDayBefore6Hour];
        let IsFixturePtCard = config.enumMdCardStatus.fixture;
        let isMdCompleted = false;
        if (gcStats) {
            gamdayId = gcStats.IsFixturePtCardGDID;
            IsFixturePtCard = gcStats.IsFixturePtCard;
            isMdCompleted = (gcStats["GameDay"] == gcStats["PtGameday"]);
            let objRow = {};
            if (gcStats.Md1Date) {
                objRow = { id: gamdayId, date: gcStats.Md1Date, points: gcStats.Md1Points, mdNo: 1 };
                arrMatchDay.push(objRow);
            }
            if (gcStats.Md2Date) {
                objRow = { id: gamdayId, date: gcStats.Md2Date, points: gcStats.Md2Points, mdNo: 2 };
                arrMatchDay.push(objRow);
            }
            if (gcStats.Md3Date) {
                objRow = { id: gamdayId, date: gcStats.Md3Date, points: gcStats.Md3Points, mdNo: 3 };
                arrMatchDay.push(objRow);
            }
            if (gcStats.Md4Date) {
                objRow = { id: gamdayId, date: gcStats.Md4Date, points: gcStats.Md4Points, mdNo: 4 };
                arrMatchDay.push(objRow);
            }

            // adding condition for match final points
            if (common.isEndOfSeason(gcStats.TrCode) && this.props.finalPoints && this.props.finalPoints.length > 0) {
                // arrMatchDay = [];
            }
        }
        let sRoundName = gamdayId ? trans[("rd" + gamdayId)] : trans.rd;
        sRoundName = sRoundName ? sRoundName : trans.rd;
        let enumScinarioCode = self.props.enumScinarioCode;
        let COOKIE_GM = config.COOKIE_GM;
        let parsedCookieGM = null;
        let cookieGM = common.getCookie(COOKIE_GM);
        let badgeID = 0;
        if (cookieGM) {
            parsedCookieGM = common.parseCookie(cookieGM);
            if (parsedCookieGM) {
                // badgeID = parsedCookieGM.BadgeId;
            }
        }
        let imgSrc = config.playerImgBase + `badges/${badgeID}.png`;
        return <div className="si-card si-points-card">
            <div className="si-mypnts-block">
                <div className="si-mt-block">
                    <div className="si-pntcrd-block">
                        <div className="si-text-descp">{ sRoundName }</div>
                        {
                            self.renderPointSofar(arrSchedule, arrMatchDay, enumScinarioCode, IsFixturePtCard, trans, isMdCompleted)
                        }
                    </div>
                    <div className="si-mail-block">
                        <img src={ imgSrc } alt={ "" } /></div>
                </div>
                <div className="si-points-block">
                    <div className="si-stats-details">
                        <div className="si-points-table">
                            {
                                self.renderDetails(arrMatchDay, trans)
                            }
                        </div>
                    </div>
                </div>
                <div className="button-block">
                    {
                        self.renderViewPointsBtn(arrSchedule, enumScinarioCode, IsFixturePtCard, trans)
                    }
                </div>
            </div>
        </div>
    }
}

export default MdStatus;


// WEBPACK FOOTER //
// ./src/components/home/cards/MdStatus.js